export default __webpack_public_path__ + "static/media/doc-filter.b6ffc03c.svg";